import React, { memo } from 'react';

import { Pagination as AntPagination } from 'antd';
import PropTypes from 'prop-types';

import styles from './Pagination.module.scss';

export function itemRender(current, type, originalElement) {
    if (type === 'prev') {
        return <a className={styles.pagePrevNextButton}>Anterior</a>;
    }
    if (type === 'next') {
        return <a className={styles.pagePrevNextButton}>Próxima</a>;
    }
    return originalElement;
}

const Pagination = memo(({
    ...others
}) => {
    return (
        <AntPagination
            {...others}
            size="small"
            pageSize={15}
            showSizeChanger={false}
            itemRender={itemRender}
        />
    );
});

Pagination.propTypes = {
    current: PropTypes.number,
    total: PropTypes.number,
    loading: PropTypes.bool,
};

export default Pagination;
